/** Observer object made for React useEffect: the subscribe function returns a clean up function which unsubscribes when React components unmount. */
export class Observable<T> {
  observers: Function[];

  constructor() {
    this.observers = [];
  }

  notify(data: T) {
    this.observers.forEach((observer) => observer(data));
  }

  subscribe(f: (typeof this.observers)[number]) {
    this.observers.push(f);
    return () => {
      [...this.observers].forEach((observer, index) => {
        if (observer === f) {
          this.observers.splice(index, 1);
        }
      });
    };
  }
}
